import { NumberParam, StringParam } from "use-query-params";

// search params config
export const queryParamsPrestadorConfig = {
  search: StringParam,
  limit: NumberParam,
};

export const initialFilterPrestador = {
  limit: 100,
};
